<template>
  <vx-card>
    <select-status
      :data="data.status"
      @change="data.status = $event"
    />

    <vs-input
      label="Title ID"
      v-model="data.titleId"
      class="mt-5 mr-3 w-full"
    />

    <vs-input
      label="Title En"
      v-model="data.titleEn"
      class="mt-5 mr-3 w-full"
    />

    <vs-input
      label="Subtitle ID"
      v-model="data.subtitleId"
      class="mt-5 mr-3 w-full"
    />

    <vs-input
      label="Subtitle En"
      v-model="data.subtitleEn"
      class="mt-5 mr-3 w-full"
    />

    <div class="mt-10 d-block">
      <draggable :list="data.itemList" :group="{name:'tags',  pull:'clone', put:false }" class="p-2 cursor-move mb-5">
        <vs-chip
          v-for="(listItem, index) in data.itemList"
          :key="index" closable
          @click="remove(index)"
        >
          <vs-avatar :src="listItem.logoUrl" :text="listItem.name" />
          {{ listItem.name }}
        </vs-chip>
      </draggable>

    </div>

    <br />

    <div class="mt-10 d-block">
      <select-business input-class="mt-10" label="Search business to add" @change="onSelect" />
    </div>

    <div
      class="flex flex-wrap items-right justify-content-right p-6"
      slot="footer"
    >
      <vs-button
        class="ml-auto"
        @click="submit"
      >Save</vs-button>
    </div>
  </vx-card>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'

export default {
  computed: {
    data: {
      get() {
        const data = this.$store.getters['recommendationBusiness/arrayData'].find((i) => i.id === this.$route.params.id)
        return data || { itemList: [] }
      }
    }
  },
  components: { draggable },
  methods: {
    onSelect(val) {
        this.data.itemList.push(
          _.pick(val, [
            'name',
            'slug',
            'logoUrl',
            'thumbnailUrl',
            'category',
            'email',
            'phone',
            'address',
            'socmedLink'
          ]))
      },
      submit () {

        this.$vs.loading({
          text: 'Saving Changes'
        })

        this.$store.dispatch('recommendationBusiness/set', this.data)
          .then(() => this.$vs.loading.close())
      },
      remove (index) {
        this.data.itemList.splice(index, 1)
        this.submit()
      }
  }
}
</script>
